export default {
  async onError (err) {
    const env = process.env.NODE_ENV || 'development';
    if (env === 'development') {
      console.log('ERROR: ' + err.message);
      console.log(err);
    }
  }
};

/*
example:
 http://stackoverflow.com/questions/6484528/what-are-the-best-practices-for-javascript-error-handling
 function log(sev,msg) {
 if (Math.random() > 0.1) return; // only log some errors

 var img = new Image();
 img.src = "log.php?sev=" +
 encodeURIComponent(sev) +
 "&msg=" + encodeURIComponent(msg);
 }
 */



/** WEBPACK FOOTER **
 ** ./src/services/errorService.js
 **/